var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9459 52.8874L37.4626 26.4041C40.1751 19.5791 38.7751 11.5291 33.2626 5.98742C26.5542 -0.720915 16.1126 -1.33342 8.67507 4.09159L19.8751 15.3208L15.7334 19.4333L4.56257 8.26242C-0.862429 15.6708 -0.249929 26.1416 6.4584 32.8208C11.8834 38.2458 19.7876 39.6749 26.5542 37.1374L53.1251 63.7083C54.2626 64.8458 56.1001 64.8458 57.2376 63.7083L63.9459 56.9999C65.1126 55.8916 65.1126 54.0541 63.9459 52.8874ZM55.1959 57.5541L27.6042 29.9624C25.8251 31.2749 23.8417 32.0624 21.7709 32.3541C17.8042 32.9374 13.6334 31.7416 10.6001 28.7083C7.82924 25.9666 6.5459 22.2916 6.75007 18.6749L15.7626 27.6874L28.1292 15.3208L19.1167 6.30825C22.7334 6.10408 26.3792 7.38742 29.1501 10.1291C32.3001 13.2791 33.4959 17.6249 32.7667 21.6791C32.4167 23.7499 31.5417 25.6749 30.2001 27.3958L57.7626 54.9583L55.1959 57.5541Z",
    fill: "#CBDFF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutage);
export default __webpack_public_path__ + "static/media/outage.bf9c7b0ca8409100b9078f5b81070a26.svg";
export { ForwardRef as ReactComponent };